// extracted by mini-css-extract-plugin
module.exports = {"warning":"Warning_warning__APwdZ","warning_icon":"Warning_warning_icon__1Dg6u"};